module.exports = __webpack_public_path__ + "img/send.31776b01.png";